import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tooltip: {
		id: 'business-timeline.common.dependency-icon.tooltip',
		defaultMessage: 'Create a dependency',
		description: 'Icon tool tip message for creating issue dependencies',
	},
});
